import { render } from "./MySkills.vue?vue&type=template&id=09353e8e"
import script from "./MySkills.vue?vue&type=script&lang=js"
export * from "./MySkills.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__